<header class="main-header">
  <!-- Logo -->
  <a fxHide.lt-md href="/" class="logo">
    <span class="logo-mini">
      <img [src]="logo ? logo : 'assets/img/logo-white.png'" width="40%" />
    </span>
    <span class="logo-lg">
      <img [src]="logo ? logo : 'assets/img/logo-white.png'" width="20%" />
    </span>
  </a>

  <!-- Header Navbar -->
  <nav class="navbar navbar-static-top" role="navigation" style="background-color:#29c1fa">
    <!-- Sidebar toggle button-->
    <a href="#" id="nav-button" class="sidebar-toggle" data-toggle="push-menu" role="button">
      <span class="sr-only">Toggle navigation</span>
    </a>
    <!-- Navbar Right Menu -->
    <div class="navbar-custom-menu">
      <ul class="nav navbar-nav">
        <li *ngIf="
            group == groupTypes.ADMIN || isPrivateUser
          " style="margin-top: 4px;">
          <form style="padding: 0 !important; " class="navbar-form navbar-left" role="search" fxLayout.lt-md="row"
            fxLayoutGap.lt-md="10px">
            <div class="form-group" *ngIf="
            group == groupTypes.ADMIN
          ">
              <span fxHide.lt-md style="color: #f6f6f6; vertical-align: inherit;">Search for
              </span>
              <select style="padding: 0 !important; height: 2em; margin: 0px 8px;" #selectElem class="form-control"
                [(ngModel)]="category" [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="searchTerm$.next(searchTerm.value)">
                <option value="user">Users</option>
                <option value="ticket">Tickets</option>
              </select>
            </div>
            <div class="form-group">
              <input style="width: 100%; padding: 2px;" (keyup)="searchTerm$.next($event.target.value)" #searchTerm
                type="text" class="form-control" (focusout)="focusOut()" class="dropdown-toggle" data-toggle="dropdown"
                placeholder="Search..." />
              <i class="fa fa-spinner fa-spin errspan" aria-hidden="true"
                [style.visibility]="loading ? 'visible' : 'hidden'"></i>
              <ul class="list-group form-group" id="search-results" *ngIf="results.length > 0 && category == 'user'"
                role="menu">
                <li class="list-group-item" *ngFor="let result of results">
                  <a routerLink="/user/view/{{ result.id }}">
                    <b class="list-group-item-text">{{ result.first_name }} {{ result.last_name }}</b>
                  </a>
                </li>
              </ul>

              <ul class="list-group form-group" id="search-results" *ngIf="results.length > 0 && category == 'ticket'"
                role="menu">
                <li class="list-group-item" *ngFor="let ticket of results">
                  <a (click)="showModal('ticket', ticket)">
                    <b class="list-group-item-text">{{ ticket.username }} {{ ticket.id }}</b>
                  </a>
                </li>
              </ul>
            </div>
          </form>
        </li>
        <li class="dropdown user user-menu">
          <!-- Menu Toggle Button -->
          <a href="#" class="dropdown-toggle" data-toggle="dropdown">
            <span [hidden]="!userDetails?.first_name" class="hidden-xs">{{ userDetails.first_name }}
              {{ userDetails.last_name }}</span>
            <span [hidden]="userDetails?.first_name">Super User</span>
          </a>
          <ul class="dropdown-menu">
            <!-- The user image in the menu -->
            <li class="user-header" [hidden]="!userDetails?.first_name">
              <!-- <img src="assets/img/user2-160x160.jpg" class="img-circle" alt="User Image"> -->
              <p>
                {{ userDetails.first_name }} {{ userDetails.last_name }} -
                {{ userDetails.group }}
              </p>
            </li>

            <li class="user-header" [hidden]="userDetails?.first_name">
              <p>{{ userDetails.email }} - {{ userDetails.group }}</p>
            </li>
            <!-- Menu Footer-->
            <li class="user-footer">
              <div class="pull-left">
              </div>
              <div class="pull-right">
                <a (click)="logout()" class="btn btn-default btn-flat">Sign out</a>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</header>